import { DATABASE } from '../../constants/Constant'
import { getDocument, setDocument } from './firebaseCliDaoMethods'

function getTableColumnsDBDocPath(tenantId, userId, tableName) {
  return `/${DATABASE.TENANT_COL}/${tenantId}/${DATABASE.USERS}/${userId}/${DATABASE.USER_PREFERENCE}/${DATABASE.PAGE_PREFERENCE}/${tableName}`
}

const fetchTableColumns = (params) => {
  let colPath = getTableColumnsDBDocPath(params.tenantId, params.userId, params.tableName)
  return new Promise((resolve) => {
    getDocument(colPath, DATABASE.TABLE_PREFERENCE)
      .then((docRef) => {
        let data = []
        if (docRef.exists()) {
          let doc = docRef.data()
          if (Object.keys(doc).length && doc.column) {
            let colKeys = Object.keys(doc.column)
            if (colKeys.length) {
              data = colKeys.reduce((acc, key) => {
                if (doc.column[key]) acc.push(key)
                return acc
              }, [])
            }
          }
        }
        resolve(data)
      })
      .catch((e) => {
        console.log('Error while fetching table columns list error msg:', e)
        resolve([])
      })
  })
}

const updateSelectedColumnsInDB = (params) => {
  const colPath = getTableColumnsDBDocPath(params.tenantId, params.userId, params.tableName)
  const data = params.selectedCols.reduce((acc, key) => {
    acc[key] = true
    return acc
  }, {})
  return new Promise((resolve) => {
    setDocument(colPath, DATABASE.TABLE_PREFERENCE, { column: data }).then((res) =>{
      resolve(params.selectedCols)
    }).catch((e)=>{
      console.log('Error while updating columns data in DB:', e)
      resolve([])
    })
  })
}

const updateColumnsWidthInDB = async (params) => {
  try {
    const colPath = getTableColumnsDBDocPath(params.tenantId, params.userId, params.tableName)
    const docRef = await getDocument(colPath, DATABASE.COLUMN_WIDTH)

    const existingData = docRef.exists() ? docRef.data().column || {} : {}
    const mergedData = { ...existingData, ...params.colWidths }

    const isUpdated = Object.entries(params.colWidths).some(
      ([key, value]) => existingData[key] !== value
    )

    if (!isUpdated) {
      return existingData
    }

    await setDocument(colPath, DATABASE.COLUMN_WIDTH, { column: mergedData })
    return mergedData
  } catch (error) {
    console.error('Error while updating column widths in DB:', error)
    return {}
  }
}


const fetchTableColumnsWidth = (params) => {
  let colPath = getTableColumnsDBDocPath(params.tenantId, params.userId, params.tableName);
  return new Promise((resolve) => {
    getDocument(colPath, DATABASE.COLUMN_WIDTH)
      .then((docRef) => {
        let columnWidths = {};

        if (docRef.exists()) {
          let doc = docRef.data();

          if (doc.column) {  // Assuming the top-level key is 'column'
            Object.keys(doc.column).forEach(columnKey => {
              const columnWidth = doc.column[columnKey];

              if (typeof columnWidth === 'number') {
                columnWidths[columnKey] = columnWidth; // Directly assign the width value
              } else {
                // Handle or log unexpected format for a column width
                console.warn(`Unexpected format for column: ${columnKey}, value: ${columnWidth}`);
              }
            });
          }
        }

        resolve(columnWidths);
      })
      .catch((e) => {
        console.log('Error while fetching table columns width error msg:', e);
        resolve([]);  // Resolve with an empty object to indicate no widths were found
      });
  });
};


export { fetchTableColumns, updateSelectedColumnsInDB,fetchTableColumnsWidth, updateColumnsWidthInDB }